// extracted by mini-css-extract-plugin
export var chevronIcon = "_cx-2";
export var teamName = "_cx-1";
export var teamSwitcherButton = "_cx-0";